import { gettext } from '@eventbrite/i18n';

export const PASSWORD_TOO_SHORT = gettext('must be at least 8 characters');
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_STRENGTH_TO_METER_CONVERSION = 25;
export const PASSWORD_STRENGTH_LABELS: any = {
    0: gettext('is very weak'),
    1: gettext('is weak'),
    2: gettext('is moderate'),
    3: gettext('is strong'),
    4: gettext('is very strong'),
};
